import { SelectInterface } from '@shared/interfaces/select.interface'
import { OptionOrderTypeEnum } from '@modules/options-module/orders/enums/option-order-type.enum'

export const OptionsOrdersTypesConstant: SelectInterface<OptionOrderTypeEnum>[] = [
	{
		title: 'optionsOrders.optionsType.orders',
		value: OptionOrderTypeEnum.ORDERS,
	},
	{
		title: 'optionsOrders.optionsType.postTrading',
		value: OptionOrderTypeEnum.POST_TRADING,
	},
]
